module.exports = __webpack_public_path__ + "static/img/wisdomZhili6.afb9b284.png";